import { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { SessionProvider, useSession } from './context/SessionContext'
import { Shell } from './components/Shell'
import { LoginView } from './views/LoginView'

// AppGate is the only place that decides between login and the shell.
function AppGate() {
  const { status, recheck } = useSession()

  if (status === 'loading') {
    return (
      <div className="app-splash" role="status" aria-live="polite" aria-label="Loading">
        <span>Loading…</span>
      </div>
    )
  }
  if (status === 'error') {
    return (
      <div className="app-splash" role="alert">
        <p>Can’t reach the Symone gateway.</p>
        <button type="button" className="btn" onClick={recheck}>
          Retry
        </button>
      </div>
    )
  }
  if (status === 'unauthenticated') return <LoginView />
  return <Shell />
}

export default function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { retry: 1, staleTime: 30_000 },
          mutations: { retry: 0 },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <AppGate />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
